<template>
  <layout v-if="profileLoaded">
    <template v-slot:title>Advanced</template>
    <tabbed-view :default-tab="defaultTab">
      <template v-slot:tabs="{ context, tabClicked }">
        <tab
          id="advanced-tags"
          v-if="!sharedoId && isDocumentAdmin"
          :context="context"
          label="Tags"
          @click="tabClicked"
        />
        <tab
          id="meta-rebuild"
          :context="context"
          label="Repair"
          @click="tabClicked"
        />
      </template>
      <template v-slot:content="{ context }">
        <tab-pane id="advanced-tags" v-if="!sharedoId && isDocumentAdmin" :context="context">
          <advanced-tags />
        </tab-pane>
        <tab-pane id="meta-rebuild" :context="context">
          <meta-rebuild />
        </tab-pane>
      </template>
    </tabbed-view>
  </layout>
</template>
<script>
import profile from "@/mixins/profile";
import { TabbedView, Tab, TabPane } from "@/components/common/tabs/index.js";
import MetaRebuild from "@/components/advanced/MetaRebuild.vue";
import AdvancedTags from "@/components/advanced/AdvancedTags.vue";
import { ADMIN_DOCUMENT_ASSEMBLY } from "@/constants/permissions";
import customProperties from "@/services/word/customPropertiesService";

export default {
  components: { TabPane, Tab, TabbedView, MetaRebuild, AdvancedTags },
  mixins: [profile],
  data: function () {
    return {
      sharedoId: "",
    };
  },
  computed: {
    isDocumentAdmin: function () {
      return this.hasPermission(ADMIN_DOCUMENT_ASSEMBLY);
    },
    defaultTab: function () {
      return !this.sharedoId && this.isDocumentAdmin ? "advanced-tags" : "meta-rebuild";
    },
  },
  beforeCreate: async function () {
    this.sharedoId = await customProperties.get("SharedoActivityId");
  },
};
</script>
